import { render } from "./LocumsTab.vue?vue&type=template&id=dcecde92"
import script from "./LocumsTab.vue?vue&type=script&lang=js"
export * from "./LocumsTab.vue?vue&type=script&lang=js"

import "./LocumsTab.vue?vue&type=style&index=0&id=dcecde92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__